import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuth } from "../baseQuery";

export interface Note {
  _id?: string;
  classe: string;
  eleves: any[];
  matiere: string;
  trimestre: string;
  type: string;
  date: string;
}

interface UpdateNoteData {
  _id?: string;
  updateData: any;
  eleves: any[];
}

export const noteSlice = createApi({
  reducerPath: "Note",
  baseQuery: baseQueryWithAuth("notes"),
  tagTypes: ["Note"],
  endpoints(builder) {
    return {
      fetchNotes: builder.query<Note[], number | void>({
        query() {
          return `/getNotes`;
        },
        providesTags: ["Note"],
      }),
      addNote: builder.mutation<void, Note>({
        query(payload) {
          return {
            url: "/newNote",
            method: "POST",
            body: payload,
          };
        },
        invalidatesTags: ["Note"],
      }),
      updateNote: builder.mutation<void, UpdateNoteData>({
        query: ({ _id, ...rest }) => ({
          url: `/updateNote/${_id}`,
          method: "PATCH",
          body: rest,
        }),
        invalidatesTags: ["Note"],
      }),
        deleteNote: builder.mutation<void, Note>({
          query: (_id) => ({
            url: `/deleteNote/${_id}`,
            method: "Delete",
          }),
          invalidatesTags: ["Note"],
        }),
        bulkDeleteNotes: builder.mutation<{ deleted: number }, string[]>({
          query(ids) {
            return {
              url: "/bulkDelete",
              method: "POST",
              body: { ids },
            };
          },
          invalidatesTags: ["Note"],
        }),
    };
  },
});

export const { useAddNoteMutation, useFetchNotesQuery, useDeleteNoteMutation, useUpdateNoteMutation, useBulkDeleteNotesMutation } = noteSlice;
